var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Footer"},[_c('h1',[_vm._v("Kies een onderdeel op het stadsgezicht uit 1644 om verder te gaan")])])
}]

export { render, staticRenderFns }